module.exports = __webpack_public_path__ + "img/icon_code.2fddfd5d.png";